// This file was auto-generated by querybuilder/Apollo and should not be edited.

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LetterStylesQuery
// ====================================================

export interface LetterStylesQuery_letterStyles {
  /**
   * Inline CSS to embed when generating PDFs from HTML.
   */
  inlinePdfCss: string;
  /**
   * A list of stylesheet URLs to include in the HTML version of a letter.
   */
  htmlCssUrls: string[];
}

export interface LetterStylesQuery {
  /**
   * Details about CSS styling for business letters.
   */
  letterStyles: LetterStylesQuery_letterStyles;
}


export const LetterStylesQuery = {
  // The following query was taken from LetterStylesQuery.graphql.
  graphQL: `query LetterStylesQuery {
  letterStyles {
    inlinePdfCss,
    htmlCssUrls
  }
}
`,
  name: "LetterStylesQuery",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, ): Promise<LetterStylesQuery> {
    return fetchGraphQL(LetterStylesQuery.graphQL);
  },

};

export const fetchLetterStylesQuery = LetterStylesQuery.fetch;